// extracted by mini-css-extract-plugin
module.exports = {"optioned-message":"_39MJ3v","header-text":"_3Z2ENw","btn":"kqACee","disabled":"_3qljvD","options":"_3A0nv0","option-btn":"_1CCD1t","option-btn-subtext":"_18Eywe"};